import { render, staticRenderFns } from "./PopComment.vue?vue&type=template&id=2447f5cc&scoped=true&"
import script from "./PopComment.vue?vue&type=script&lang=js&"
export * from "./PopComment.vue?vue&type=script&lang=js&"
import style0 from "./PopComment.vue?vue&type=style&index=0&id=2447f5cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2447f5cc",
  null
  
)

/* custom blocks */
import block0 from "./PopComment.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports